import * as moment from 'moment';
import { Moment } from "moment";
import { LocationModel, LocationNameModel, PersonModel, IsOwn, IsOwnCompany, CompanyDataModel, PhoneNumberModel, EmailModel } from "../common/models/CommonModels";
import { RecurrenceModel, getEmptyRecurrenceModel } from '../common/models/Recurrence';

// Unit types are also added to localizations.ts for proper translations.
export enum UnitType {
    Trailer = "trailer",
    Container20 = "container20",
    ContainerOver20 = "containerOver20",
    Unspecified = "unspecified"
}

export interface UnitModelBase<TLocation, TDate> {
    id: string;
    readyTime: TDate;
    deliveryTime: TDate;
    trailerType: UnitType;
    departureCity: TLocation;
    destinationCity: TLocation;
    trailerIdentifier: string;
    details: string;
    contractPrice?: number;
    properties: UnitProperties;
    createdBy: string;
    companyId: string;
    deletedAt?: TDate;
    isDistanceCheckEnabled: boolean;
    searchDistance: number;
}

export interface AddUnitModel extends UnitModelBase<LocationNameModel, Moment> {
    recurrence: RecurrenceModel;
}

export interface UnitModel extends UnitModelBase<LocationModel, Moment>, IsOwn, IsOwnCompany {
    company: CompanyDataModel<PhoneNumberModel, EmailModel>
    coordinator: PersonModel
    reportNumber: string;
    recurrence: RecurrenceModel;
}

export interface UnitProperties {
    adr: boolean;
    explosive: boolean;
    glass: boolean;
    tank: boolean;
    thermal: boolean;
    mega: boolean;
    container20: boolean;
    containerOver20: boolean;
    pieceGoods: boolean;
    bulkGoods: boolean;
}

export enum DeleteUnitReason {
    FoundTruckForUnitFromThisApp = "FoundTruckForUnitFromThisApp",
    FoundTruckForUnitElsewhere = "FoundTruckForUnitElsewhere",
    ErrorUnitWasNotFree = "ErrorUnitWasNotFree",
    OtherReason = "OtherReason",
}

export interface DeleteUnitModel {
    id: string;
    reason?: DeleteUnitReason;
    description: string;
    contractCompanyId?: string;
}

export const getEmptyDeleteUnitModel = () => <DeleteUnitModel>{
    id: "",
    reason: undefined,
    contractCompanyId: ""
};

export type RecurrenceType = "daily" | "weekly" | "monthly";

export const getEmptyUnitModel = (): AddUnitModel => {
    const startDate = moment().add(1, "hours").minute(0).second(0).millisecond(0);
    return {
        departureCity: {
            id: "",
            name: ""
        },
        destinationCity: {
            id: "",
            name: ""
        },
        readyTime: startDate,
        deliveryTime: startDate.clone().add(1, "hours"),
        trailerType: UnitType.Unspecified,
        details: "",
        trailerIdentifier: "",
        properties: {
            adr: false,
            explosive: false,
            thermal: false,
            tank: false,
            glass: false,
            mega: false,
            containerOver20: false,
            container20: false,
            pieceGoods: false,
            bulkGoods: false
        },
        recurrence: getEmptyRecurrenceModel(startDate),
        createdBy: "",
        companyId: "",
        id: "",
        isDistanceCheckEnabled: true,
        searchDistance: 50
    }
}


// WEBPACK FOOTER //
// ./src/units/UnitModels.ts